import { render } from "./ButtonLabel.vue?vue&type=template&id=7f874f06&lang=pug"
import script from "./ButtonLabel.vue?vue&type=script&lang=js"
export * from "./ButtonLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__